<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeBase from '../../../../employees/components/EmployeeBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        navItem: {
            label: 'People',
            icon: 'pi pi-user',
            route: '/(app)/people/employees/',
        },
        navConfig: {
            order: 30,
            navHeader: true,
            leftDrawer: true,
        },
        childNavItems: [
            {
                label: 'Employees',
                route: '/(app)/people/employees/',
            },
            {
                label: 'Availability',
                route: '/(app)/people/availability/',
            },
            {
                label: 'Broadcasts',
                route: '/(app)/people/broadcasts/',
            },
            {
                label: 'Time Off',
                route: '/(app)/people/time-off/',
            },
        ],
    }
})
</script>

<template>
  <EmployeeBase />
</template>